import React from 'react';
import ReactDOM from 'react-dom';
import history from './history'
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { Router } from 'react-router-dom'
import { CookiesProvider } from 'react-cookie';

ReactDOM.render((
    <CookiesProvider>
        <Router history={history}>
            <App />
        </Router>
    </CookiesProvider>), document.getElementById('root'));
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js